@if (!errorType) {
<tec-pwcs-layout
    [ngClass]="{ dark: designService.isDarkMode()}"
    [title]="tutorial ? '' : 'CONNECTIONS.IRPF.OTP_TITLE' | translate"
    [subtitle]="subtitle"
    [footerLabel]="tutorial ? ('GENERAL.TUTORIAL_CONNECTION_ENCRYPTION' | translate) : ''">

    <tec-progress [value]="progressService.getValue()"></tec-progress>

    <ng-container content>
        @if (tutorial) {
            <pwcs-inline-svg
                [src]="'assets/images/connection-tutorial' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                idSuffix="irpf-connection-tutorial"
            />
        } @else {
            <!-- PHASE 1 -->
            @if (!mode_otp) {
                <!-- <tec-alert type="message" [msg]="'CONNECTIONS.IRPF.TAG_TITLE' | translate" [status]="'success'" hiddenCloseButton></tec-alert> -->
                <tec-tile [formGroup]="form" class="custom-tile">
                    <tec-form-group [label]="'CONNECTIONS.IRPF.FORM.DOCUMENT_ID' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('nif'))">
                        <tec-input
                            formControlName="nif"
                            [placeholder]="'CONNECTIONS.IRPF.FORM.DOCUMENT_ID_PLACEHOLDER' | translate"
                            [hasError]="reactiveFormService.hasError(form.get('nif'))"
                        ></tec-input>
                    </tec-form-group>
                    @if (isValidDni(form.get('nif').value)) {
                        <tec-form-group [label]="'CONNECTIONS.IRPF.FORM.VALID_TO' | translate"
                            [errorMsg]="reactiveFormService.hasMsgError(form.get('valid_to'))">
                            <tec-datepicker
                                formControlName="valid_to"
                                placeholder="DD/MM/YYYY"
                                [minDate]="today"
                                [hasError]="reactiveFormService.hasError(form.get('valid_to'))"
                            ></tec-datepicker>
                            <tec-link (click)="isVisibleExpeditionHelp = true">{{ 'GENERAL.BUTTON.GET_HELP' | translate }}</tec-link>
                        </tec-form-group>
                    }
                    @if (isValidNie(form.get('nif').value)) {
                        <tec-form-group [label]="'CONNECTIONS.IRPF.FORM.SOPORTE' | translate"
                            [errorMsg]="reactiveFormService.hasMsgError(form.get('soporte'))">
                            <tec-input
                                formControlName="soporte"
                                [placeholder]="'CONNECTIONS.IRPF.FORM.SOPORTE_PLACEHOLDER' | translate"
                                [hasError]="reactiveFormService.hasError(form.get('soporte'))"
                            ></tec-input>
                            <tec-link (click)="isVisibleSoporteHelp = true">{{ 'GENERAL.BUTTON.GET_HELP' | translate }}</tec-link>
                        </tec-form-group>
                    }
                </tec-tile>
                <ng-container [ngTemplateOutlet]="manualLink"></ng-container>
            }
            <!-- PHASE 2 -->
            @if (mode_otp) {
                <tec-tile>
                    <div style="display: flex;align-self: center;gap: 5px;">
                        <tec-icon name="icon-clock"></tec-icon>
                        <span>{{countdown}}</span>
                    </div>
                    <tec-code-input
                        [errorMsg]="codeOtpError"
                        (formValue)="codeOtpError = ''; codeOtp = $event"
                    ></tec-code-input>
                    <span style="display: ruby; align-self: center;">
                        {{ 'CONNECTIONS.WORK_LIFE.SMS_NOT_RECEIVED' | translate }} <tec-link (click)="sendForm()">{{ 'CONNECTIONS.WORK_LIFE.SMS_RESEND' | translate }}</tec-link>
                    </span>
                </tec-tile>
                <ng-container [ngTemplateOutlet]="manualLink"></ng-container>
            }
        }
    </ng-container>
    <ng-container actions>
        @if (tutorial) {
            <tec-button
                size="lg"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="finishTutorial()"
            ></tec-button>
        } @else {
            <!-- PHASE 1 -->
            @if (!mode_otp) {
            <tec-button
                size="lg"
                [label]="'GENERAL.BUTTON.GET_CODE' | translate"
                (clickEvent)="sendForm()"
            ></tec-button>
            }
            <!-- PHASE 2 -->
            @if (mode_otp) {
            <tec-button
                size="lg"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="sendOtpCode()"
            ></tec-button>
            }
        }
    </ng-container>

    <!-- NAV HELP -->
    <tec-nav-help
        [elements]="tutorial ? navsHelpTutorial : navsHelp"
        (clickEvent)="navHelpChange($event)"
    ></tec-nav-help>
</tec-pwcs-layout>
}

<!-- ERRORS -->
@if (errorType) {
<tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode()}">
    <ng-container content>
        @switch (errorType) {
            @case ('otp-expired') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.IRPF.ERROR.OTP_EXPIRED_TITLE' | translate"
                    [subtitle]="operation.config?.numberOfTries < operation.config?.total_tries ? ('CONNECTIONS.IRPF.ERROR.OTP_EXPIRED_DESCRIPTION' | translate) : ('CONNECTIONS.IRPF.ERROR.OTP_EXPIRED_DESCRIPTION_2' | translate)"
                    tagIconStatus="default"
                    icon="icon-alert">
                    <ng-container [ngTemplateOutlet]="helpLink"></ng-container>
                </tec-tile>
            }
            @case ('robot') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.IRPF.ERROR.ROBOT_TITLE' | translate"
                    [subtitle]="operation.config?.numberOfTries < operation.config?.total_tries ? ('CONNECTIONS.IRPF.ERROR.ROBOT_DESCRIPTION' | translate) : ('CONNECTIONS.IRPF.ERROR.ROBOT_DESCRIPTION_2' | translate)"
                    tagIconStatus="default"
                    icon="icon-alert">
                    <ng-container [ngTemplateOutlet]="helpLink"></ng-container>
                </tec-tile>
            }
            @case ('insufficient-data') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.IRPF.ERROR.INSUFFICIENT_DATA_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.IRPF.ERROR.INSUFFICIENT_DATA_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('server') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.IRPF.ERROR.SERVER_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.IRPF.ERROR.SERVER_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert">
                </tec-tile>
            }
        }
    </ng-container>
    <ng-container actions>
        @if (errorType === 'otp-expired' || errorType === 'robot') {
            @if (operation.config?.numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="operation.config?.['fallback']?.['type'] !== MODE.MANUAL ? 'default' : 'secondary'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    [size]="'lg'"
                    (clickEvent)="sendForm()"
                ></tec-button>
            }
            @if (operation.config?.['fallback']?.['type'] === MODE.MANUAL) {
                <tec-button
                    icon="icon-paperclip"
                    iconPosition="left"
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ATTACH' | translate"
                    (clickEvent)="errorType = null; changeToManualUpload()"
                ></tec-button>
            }
        }
    </ng-container>
</tec-pwcs-layout>
}

<ng-template #manualLink>
    @if (operation.config?.['fallback']?.['type'] === MODE.MANUAL) {
    <span style="display: ruby;">
        {{ 'GENERAL.PREFER' | translate }} <tec-link (click)="changeToManualUpload()">{{ 'CONNECTIONS.WORK_LIFE.ADD_MANUALLY' | translate }}</tec-link>
    </span>
    }
</ng-template>

<ng-template #helpLink>
    <span>
        <tec-link (click)="isVisibleHelp = true">{{ 'GENERAL.BUTTON.GET_HELP' | translate }}</tec-link>
    </span>
</ng-template>

<app-modal-scan-qr
    [ngClass]="{'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
></app-modal-scan-qr>

<app-modal-irpf-help
    [ngClass]="{'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleHelp"
></app-modal-irpf-help>

<app-modal-nif-expidation-help
    [ngClass]="{'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleExpeditionHelp"
></app-modal-nif-expidation-help>

<app-modal-nie-soporte-help
    [ngClass]="{'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleSoporteHelp"
></app-modal-nie-soporte-help>
